module.exports = __webpack_public_path__ + "static/what-078074778ec90a6176330a60dbb327e1.mp4";